const getCountryCode = () => {
  const url = window.location.hostname;
  // strip 'www.' off the url
  const str = /^www\./.test(url) ? url.substring(4) : url;
  return str.split('.')[0];
};

export const getStoreCode = () => {
  const code = getCountryCode();

  return storeCodes[code] ? storeCodes[code].code.split('_')[0] : 'PBWW';
};

export const getStoreName = () => {
  const code = getCountryCode();

  return storeCodes[code] ? storeCodes[code].name : 'Photobook Worldwide';
}

const storeCodes = {
  dz: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  by: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  at: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  ie: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  gb: {
    code: 'PBUK_EN',
    name: 'Photobook United Kingdom',
  },
  my: {
    code: 'PBMY_EN',
    name: 'Photobook Malaysia',
  },
  sg: {
    code: 'PBSG_EN',
    name: 'Photobook Singapore',
  },
  bn: {
    code: 'PBBN_EN',
    name: 'Photobook Brunei',
  },
  hk: {
    code: 'PBHK_EN',
    name: 'Photobook Hong Kong',
  },
  id: {
    code: 'PBID_EN',
    name: 'Photobook Indonesia',
  },
  mo: {
    code: 'PBMO_EN',
    name: 'Photobook Macau',
  },
  ph: {
    code: 'PBPH_EN',
    name: 'Photobook Philippines',
  },
  tw: {
    code: 'PBTW_EN',
    name: 'Photobook Taiwan',
  },
  cn: {
    code: 'PBCN_EN',
    name: 'Photobook China',
  },
  au: {
    code: 'PBAU_EN',
    name: 'Photobook Australia',
  },
  nz: {
    code: 'PBNZ_EN',
    name: 'Photobook New Zealand',
  },
  kr: {
    code: 'PBKR_EN',
    name: 'Photobook Korea',
  },
  vn: {
    code: 'PBVN_EN',
    name: 'Photobook Vietnam',
  },
  jp: {
    code: 'PBJP_EN',
    name: 'Photobook Japan',
  },
  in: {
    code: 'PBIN_EN',
    name: 'Photobook India',
  },
  th: {
    code: 'PBTH_EN',
    name: 'Photobook Thailand',
  },
  ae: {
    code: 'PBAE_EN',
    name: 'Photobook United Arab Emirates',
  },
  us: {
    code: 'PBUS_EN',
    name: 'Photobook US',
  },
  ca: {
    code: 'PBCA_EN',
    name: 'Photobook Canada',
  },
  br: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  om: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  gh: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  ng: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  tr: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  be: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  dk: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  it: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  lu: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  nl: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  pt: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  es: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  cy: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  gr: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  mx: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  cl: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  co: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  lk: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  kh: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  bd: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  pk: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  qa: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  za: {
    code: 'PBAF_EN',
    name: 'Photobook Africa',
  },
  de: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  ru: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  ar: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  sa: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  ww: {
    code: 'PBWW_EN',
    name: 'Photobook Worldwide',
  },
  eu: {
    code: 'PBEU_EN',
    name: 'Photobook Europe',
  },
  myr: {
    code: 'MPMY_EN',
    name: 'Muslim Pro',
  },
  idr: {
    code: 'MPID_EN',
    name: 'Muslim Pro',
  },
  eur: {
    code: 'MPEU_EN',
    name: 'Muslim Pro',
  },
  usd: {
    code: 'MPUS_EN',
    name: 'Muslim Pro',
  },
  gbp: {
    code: 'MPUK_EN',
    name: 'Muslim Pro',
  },
  pers: {
    code: 'PMMY_EN',
    name: 'Personalise Me',
  },
  wwp: {
    code: 'PPMY_EN',
    name: 'Photobook Partners',
  },
};

export default storeCodes;



// WEBPACK FOOTER //
// ./src/Store/Store.staging.js